import React, { useEffect, useState } from 'react';
import './Navbar.scss';

const logo = '/assets/images/logo/logo.png';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar-container ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo-mascot-container">
        <img src={logo} alt="Logo TheSpot" className="logo-img" />
        <span className="logo-text">TheSpot</span>
      </div>
    </nav>
  );
}

export default Navbar;
